import React, {useEffect, useState} from "react";
import {Box, Button, Pagination, Typography} from "@mui/material";
import {useGetRegistrationQuery, usePostRegistrationMutation} from "./reg_api";
import {useSelector} from "react-redux";
import {RootState} from "../../store";
import RegList from "./RegList";
import SnackError from "../../components/SnackError";
import {useNavigate} from "react-router-dom";
import Title from "../navigation/Title";
import {CurrentUserInfo} from "../../session_state";
import {useHasRole} from "../../hooks/useRole";
import {UnregisteredListController} from "../people/UnregisteredWorkers";

type RegListPros = {}

export default ({}: RegListPros) => {

    const navigate = useNavigate()
    const [startReg, {isLoading, error: error1}] = usePostRegistrationMutation({});
    const seeAllRegs = useHasRole(["AllRegs"])
    const cu = useSelector<RootState, CurrentUserInfo | null>(s => s.sessionState.user);
    const defWorker = cu?.defaultWorkerID || null;
    const [selectWorker, setSelectWorker] = useState(false);
    const startRegistration = async function (workerId?:number) {
        if (!workerId && !defWorker) {
            setSelectWorker(true);
            return
        }
        const resp = await startReg({
            WorkerID: workerId ?? defWorker,
            Status: "RegNew"
        });
        if ("data" in resp && resp.data?.id) {
            navigate("/reg/" + resp.data.id + "/")
            return
        }
    };

    const pageSize = 999
    const [page, setPage] = useState(0)
    const [seq, setSeq] = useState(0)
    const {data, error, refetch} = useGetRegistrationQuery({
        user: seeAllRegs ? undefined : cu?.id,
        worker: defWorker?? undefined,
        active: true,
        sort: [{col: "StartTime", dir: "desc"}],
        pageSize,
        page: 0
    })
    useEffect(() => {
        const tm = setTimeout(() => {
            setSeq(seq + 1)
            refetch()
        }, 15000)
        return () => clearTimeout(tm)
    }, [seq]);


    if (error) {
        return <SnackError error={error}/>
    }


    const count = data?.count || 0

    if (selectWorker) {
        return <UnregisteredListController onSelect={(id) => {
            startRegistration(id);
        }}/>
    }

    return <>
        <Box sx={{p: 1}}>
            <Typography variant={"body1"}>Odprtih prijav: {data?.count}</Typography>
        </Box>

        <Box sx={{
            display: "grid",
            mt: 1,
            gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
            gridGap: "1em"
        }}>

            <Box>
                <Button variant={"contained"}
                        color={"success"}
                        disabled={isLoading}
                        sx={{width: "100%", height: "100%", minHeight: {"sm": "6em"}}}
                        onClick={() => startRegistration()}>
                    Začni delo
                </Button>
            </Box>
            <RegList items={data?.result || []}/>
        </Box>
        {count > pageSize &&
            <Pagination onChange={(e, val) => setPage(val - 1)} page={page + 1} count={Math.ceil(count / pageSize)}/>}
        <Title title={"Moje registracije"}/>
        <SnackError error={error}/>
        <SnackError error={error1}/>
    </>;
}
